import { TableCard } from '../../../../components'
import { GenerateAsoListHeader } from './components/header/GenerateAsoListHeader'
import { ListFiltersProvider } from './core/ListFiltersProvider'
import { ListViewProvider } from './core/ListViewProvider'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { GenerateAsoTable } from './table/GenerateAsoTable'

const GenerateAsoList = () => (
  <TableCard>
    <GenerateAsoListHeader />
    <GenerateAsoTable />
  </TableCard>
)

export const GenerateAsoListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <ListFiltersProvider>
          <GenerateAsoList />
        </ListFiltersProvider>
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)
